import { useTranslation } from 'react-i18next'

const MessageSignature = ({ authorType, includeSignatureLogo, logoUrl }) => {
  const { t } = useTranslation()

  if (authorType !== 'support' || !includeSignatureLogo || !logoUrl) return null

  return (
    <img
      src={logoUrl}
      alt={t('support.detail.logo_preview')}
      className="mt-2 h-auto max-w-[120px]"
    />
  )
}

export default MessageSignature
